import { isUndefinedOrNull, labels, LayerTypeGroupId, LayerTypeId, MgrLayer } from "../omnia"
import { LayerScope } from "./types"

const providers = [
    getYieldText,
    getBiomassText,
    getTerraMapText
]

export function getLayerText(layer: MgrLayer, scope: LayerScope): string {

    for (const p of providers) {

        const text = p(layer, scope)

        if (!isUndefinedOrNull(text)) {
            return text
        }


    }

    return layer.vm.description

}

function getYieldText(layer: MgrLayer, scope: LayerScope): string {

    switch (layer.typeId) {

        case LayerTypeId.Yield:
        case LayerTypeId.YieldAverage:
        case LayerTypeId.YieldTrend:
        case LayerTypeId.YieldFieldPerformance:

            const year = scope.year || scope.groupings?.year
            const crop = scope.cropId || scope.groupings?.crop

            if (year && crop) {
                return layer.vm.date?.toLocaleDateString()
            }

            if (year) {
                return layer.vm.crop?.Name
            }

            if (crop) {
                return String(layer.year)
            }

            break;

    }

}

function getBiomassText(layer: MgrLayer, scope: LayerScope): string {

    if (layer.typeId != LayerTypeId.Biomass) {
        return undefined
    }

    const crop = scope.cropId || scope.groupings?.crop
    const date = scope.groupings?.date

    if (crop && date) {
        return ""
    }

    if (crop) {
        return layer.vm.date?.toLocaleDateString()
    }

    if (date) {
        return layer.vm.crop?.Name
    }

    return [layer.vm.crop?.Name, layer.vm.date?.toLocaleDateString()].filter(t => !!t).join(" - ") || layer.vm.description

}

function getTerraMapText(layer: MgrLayer, scope: LayerScope): string {

    if (layer.vm.type?.GroupId != LayerTypeGroupId.TerraMap) {
        return undefined
    }

    const type = scope.type?.type || scope.groupings?.type
    const year = scope.year || scope.groupings?.year

    if (year && type) {
        return layer.vm.date?.toLocaleDateString()
    }

    if (type) {
        return String(layer.year)
    }

    if (year) {
        return labels.LayerTypeId(layer.typeId)
    }

}
